<script setup lang="ts">
  import { IconAi } from '@gat-ship/icons'
  import { useAiFieldHint, useAiLoading } from './useAiFormFill'

  const props = defineProps<{ name: string }>()

  const hint = useAiFieldHint(props.name)
  const aiLoading = useAiLoading()
</script>

<template>
  <span
    v-if="aiLoading"
    title="Generating…"
    class="text-primary inline-flex items-center"
  >
    <IconAi class="h-3.5 w-3.5 animate-pulse" />
  </span>
  <span
    v-else-if="hint"
    :title="hint.inferenceInfo ?? 'Filled by AI'"
    class="text-primary inline-flex items-center"
  >
    <IconAi class="h-3.5 w-3.5" />
  </span>
</template>
